<template>
  <div class="form-group" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <input
        :value="value"
        @keyup.enter.exact="$emit('enter')"
        @input="$emit('input', $event.target.value)"
        @focusout="validateOnfocusOutMethod"
        class="form-control"
        :class="{'is-invalid': v.$error || serverErrorMessage }"
        :readonly="readonly"
        :placeholder="placeholder"
        type="password"
        :id="idComputed"
        :disabled="disabled"
        />
      <p class="invalid-feedback" v-if="serverErrorMessage"> {{ $t('login_invalid_username_or_password') }} </p>
      <p class="invalid-feedback" v-if="!v.isValid"> {{ $t('field_invalid')}} </p>
      <p class="invalid-feedback" v-else-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    serverErrorMessage: {
      type: String,
      default: ''
    }
  }
}
</script>
